import { Box, Card, Label, Text, Title } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';

export function PaymentAttemptsCardSkeleton() {
  const t = useTranslationOrders();

  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('cardPayment.paymentType')}</Title>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="2">
          <Text.Skeleton width="150px" />
          <Label.Skeleton />
          <Text.Skeleton width="150px" />
        </Box>
      </Card.Body>
    </Card>
  );
}
